import React from 'react';

interface AddProjectCardProps {
  onClick: () => void;
}

export const AddProjectCard: React.FC<AddProjectCardProps> = ({ onClick }) => {
  return (
    <div 
      className="flex flex-col items-center justify-center bg-white rounded-lg shadow-md p-12 cursor-pointer hover:shadow-lg transition-shadow duration-300"
      onClick={onClick}
      style={{ 
        width: '240px', 
        height: '240px',
        background: 'white',
        borderRadius: '12px',
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)'
      }}
    >
      <div className="flex items-center justify-center w-20 h-20 bg-blue-100 rounded-full mb-6">
        <span className="text-[#0F2A4F] text-4xl font-bold">+</span>
      </div>
      <span className="text-[#0F2A4F] font-medium text-center text-lg">Add new project</span>
    </div>
  );
};
